import { RecursosHumanosActionTypes } from './recursos-humanos.actions';
import { EMPTY_BUNDLE, NotificacionBundle } from 'src/common/notificacionBundle';
import { Fichada } from 'src/common/fichada';
import { TicketsPendientes } from 'src/common/ticketsPendientes';
import { Action } from '@ngrx/store';

export interface RecursosHumanosState {
	ultimaFichada: NotificacionBundle<Fichada>;
	ultimaFichadaReady: boolean;
	ticketsPendientes: NotificacionBundle<TicketsPendientes>;
	ticketsPendientesReady: boolean;
	ready: boolean;
}

export const initialRecursosHumanosState: RecursosHumanosState = {
	ultimaFichada: null,
	ultimaFichadaReady: true,
	ticketsPendientes: null,
	ticketsPendientesReady: true,
	ready: true
}

export function recursosHumanosReducer( state = initialRecursosHumanosState, action: Action ): RecursosHumanosState {
	switch( action.type ) {
		case RecursosHumanosActionTypes.UltimaFichadaRequested:
			return { ...state, ultimaFichadaReady: false, ready: false };
		case RecursosHumanosActionTypes.UltimaFichadaLoaded:
			let ultimaFichada: NotificacionBundle<Fichada> = action["payload"]["ultimaFichada"];
			ultimaFichada = ultimaFichada == null? EMPTY_BUNDLE: ultimaFichada;
			return { ...state, ultimaFichada, ultimaFichadaReady: true, ready: state.ticketsPendientesReady };
		case RecursosHumanosActionTypes.TicketsPendientesRequested:
			return { ...state, ticketsPendientesReady: false, ready: false };
		case RecursosHumanosActionTypes.TicketsPendientesLoaded:
			let ticketsPendientes: NotificacionBundle<TicketsPendientes> = action["payload"]["ticketsPendientes"];
			ticketsPendientes = ticketsPendientes == null? EMPTY_BUNDLE: ticketsPendientes;
			return { ...state, ticketsPendientes, ticketsPendientesReady: true, ready: state.ultimaFichadaReady };
		default:
			return state;
	}
}